var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"route-title"},[_vm._v(_vm._s(_vm.route.name))]),_c('div',{staticClass:"timeline-route extended",staticStyle:{"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }